import {IMethodRequest, IResponseCustomAction} from "./index";

export const GET_LOCATIONS = 'locations/GET_LOCATIONS'
export const fetchLocations = (): IResponseCustomAction<string> => {
  return {
    method: IMethodRequest.GET,
    endpoint: 'locations',
    type: GET_LOCATIONS
  }
}